import { render } from "./YellowBack.svg?vue&type=template&id=21068d98"
const script = {}
script.render = render

export default script